"use strict"
declare function gtag(tag: string, action: string, parameters: object);
const contact = document.forms.namedItem("contact");
contact.addEventListener("submit", function (this: HTMLFormElement, event: Event) {
	event.preventDefault();
	const controls = Array.from(this.elements) as Array<HTMLInputElement | HTMLTextAreaElement>;
	const subject = (document.getElementById("contact-subject") as HTMLInputElement).value;
	const status = document.getElementById("contact-status") || document.createElement("span");
	if (!document.contains(status)) {
		status.id = "contact-status";
		document.getElementById("contact-send").parentNode.appendChild(status);
	}
	status.innerHTML = "<strong>Sending&hellip;</strong> This may take a few seconds.";
	const xhr = new XMLHttpRequest();
	xhr.open(this.method, this.action);
	const handleResponse = function (this: HTMLFormElement, event: Event) {
		if (xhr.status >= 200 && xhr.status <= 399) {
			gtag("event", "Send", {
				"event_category": "Email",
				"event_label": subject
			});
			status.classList.remove("-error");
			status.classList.add("-success");
			status.innerHTML = "<strong>Thanks!</strong> I&rsquo;ll get back to you shortly.";
		} else {
			gtag("event", "Error", {
				"event_category": "Email",
				"event_label": xhr.status.toString()
			});
			console.error(xhr.responseText);
			status.classList.add("-error");
			status.innerHTML = "<strong>Sorry!</strong> Something went wrong. Please try again.";
			controls.forEach(control => control.disabled = false);
		}
	};
	xhr.addEventListener("load", handleResponse);
	xhr.addEventListener("error", handleResponse);
	xhr.send(new FormData(this));
	controls.forEach(control => control.disabled = true);
});
const submit = document.getElementById("contact-send") as HTMLInputElement;
submit.disabled = !contact.checkValidity()
Array.from(contact.elements).forEach((control: HTMLElement) => control.addEventListener("input", function (this: HTMLElement, event: Event) {
	submit.disabled = !contact.checkValidity();
}));
(document.getElementById("contact-message") as HTMLTextAreaElement).addEventListener("input", function (this: HTMLTextAreaElement, event: Event) {
	if (this.scrollHeight > this.clientHeight) {
		this.style.height = this.scrollHeight + "px";
	}
});
